import {
	CLICK_UPDATE_SHOIRTLIST_STATUS_IS_SELECTED,
	CLICK_UPDATE_SHOIRTLIST_STATUS_IS_REPROVED
} from '../actions/actionTypes';

const initialState = {
	shortlistStatusIsSelected: undefined,
	shortlistStatusIsReproved: undefined,
};

export const shortlistUpdateReducer = (state = initialState, action: any) => {
	switch (action.type) {
		case 	CLICK_UPDATE_SHOIRTLIST_STATUS_IS_SELECTED:
			return {
				...state,
				shortlistStatusIsSelected: action.shortlistStatusIsSelected,
			};
		case CLICK_UPDATE_SHOIRTLIST_STATUS_IS_REPROVED:
			return {
				...state,
				shortlistStatusIsReproved: action.shortlistStatusIsReproved,
			};
		default:
			return state;
	}
};